import Redbone from '../../assets/music/streaming/redbone.mp3';
import SOS from '../../assets/music/streaming/sos.mp3'
import Dreams from '../../assets/music/streaming/dreams.mp3'

// PARA ADICIONAR UMA MÚSICA:
// 1. Coloque o arquivo .mp3 em src/assets/music/ (ex.: nova-musica.mp3)
// 2. Descomente o import abaixo e ajuste o nome do arquivo:
// import NovaMusica from '../../assets/music/nova-musica.mp3';
// 3. Descomente a entrada correspondente no array (duration em segundos —
//    só afeta o contador antes do primeiro play; o valor real vem do próprio áudio).

export const music = [
    {
        title: "Redbone - Come and Get Your Love ",
        source: Redbone,
        duration: 207,
    },
    {
        title: "Dire Straits - Sultans of Swing",
        source: SOS,
        duration: 348,
    },
    {
        title: "Fleetwood Mac - Dreams",
        source: Dreams,
        duration: 258,
    },

];
